import { render, staticRenderFns } from "./MediakitTagsTable.vue?vue&type=template&id=8e42848a&"
import script from "./MediakitTagsTable.vue?vue&type=script&lang=js&"
export * from "./MediakitTagsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports